import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { WarningAlert } from "./ui";
import * as auth from "../store/ducks/auth.duck";
import { verificarStatusEmail } from "../services/fastfrete-api/endpoints/meuPerfil.api";
import styles from "./EmailNaoVerificadoAlert.module.css";

export default function EmailNaoVerificadoAlert() {
	const user = useSelector((state) => state.auth.user);
	const dispatch = useDispatch();

	const contexto = user?.token_type === "transportadora" ? "transportadora" : "embarcadora";
	const linkPerfil = contexto === "transportadora" ? "/transportador/meu-perfil" : "/embarcador/meu-perfil";

	useEffect(() => {
		if (!user || user.email_verificado !== false) {
			return;
		}

		verificarStatusEmail(contexto).then(({ data }) => {
			if (data.email_verificado) {
				dispatch(auth.actions.fulfillUser({ ...user, email_verificado: true }));
			}
		}).catch(() => {});
	}, []);

	if (!user || user.email_verificado !== false) {
		return null;
	}

	return (
		<WarningAlert className={styles.wrapper}>
			<span>Seu e-mail ainda não foi confirmado. Verifique sua caixa de entrada ou solicite reenvio no seu perfil.</span>
			<Link to={linkPerfil} className={styles.btnPerfil}>Ir para perfil</Link>
		</WarningAlert>
	);
}
